'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/alert/style/css.js
// module id = 42
// module chunks = 0